require 'angular'

angular.module('workflow.settings', [])
  .constant('settings', require './settings')
